// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import jQuery  from 'jQuery';
import "./permission"
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import { timeFormat,getPicList }  from  './utils/util'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/style/index.css"
import store from './store'
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
import { pca, pcaa } from 'area-data'; // v5 or higher
import 'vue-area-linkage/dist/index.css'; // v2 or higher
import VueAreaLinkage from 'vue-area-linkage';

Vue.use(VueAreaLinkage)

window.$= jQuery ;
window.jQuery= jQuery ;
Vue.config.productionTip = false
Vue.prototype.timeFormat = timeFormat;
Vue.prototype.getPicList = getPicList;

Vue.prototype.PROFILE="/jdl/api/";
Vue.prototype.PROFILE_base="/sys/api/";
let IMG_URL = '';
if (process.env.NODE_ENV === 'development') {
  IMG_URL = 'http://localhost:8899/jdl-api/sys/common/static/'
}else{
  if (window.location.href.search('jdlboot') !== -1) {
    IMG_URL = "http://jdlboot.jiedilia.com:8899/jdl-api/sys/common/static/";
  } else {
    IMG_URL = "https://api.sisbro.cn/jdl-api/sys/common/static/";
  }
}

Vue.prototype.$IMG_URL = IMG_URL;
import BigDecimal from 'js-big-decimal'
Vue.prototype.BigDecimal = BigDecimal
import vueEsign from 'vue-esign'
Vue.use(vueEsign)
let vue =  new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js